<template>
    <div class="page-container">
      <div class="card-wrapper">
        
        <!-- Page Header -->
        <header class="page-header">
          <h1 class="main-title">Select Property for Guaranteed Rent</h1>
          <p class="subtitle">Choose properties or individual units to secure rental income.</p>
        </header>
  
        <!-- Search Input Box -->
        <!-- <div class="search-container">
          <div class="search-input-wrapper">
            <svg viewBox="0 0 24 24" class="search-icon">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            <input 
              type="text" 
              placeholder="Search by address or location" 
              v-model="searchQuery"
              class="search-input"
            />
          </div>
        </div> -->
        <div v-if="loading">
            <PageLoader></PageLoader>
        </div>
        <div v-if="properties.length == 0 && !loading">
            <EmptyState :emptyData="emptyDataObject"></EmptyState>
        </div>
  
        <!-- Global Master Select All Toggle Option -->
        <div class="global-select-bar">
          <label class="checkbox-container">
            <input 
              type="checkbox" 
              :checked="isAllEligibleSelected" 
              @change="toggleGlobalSelectAll" 
            />
            <span class="custom-checkbox"></span>
          </label>
          <div class="select-text-content">
            <span class="select-all-label">Select all properties and its units</span>
            <span class="eligible-count" style="text-align: left;">{{ totalEligibleUnitsCount }} eligible units</span>
          </div>
        </div>
  
        <!-- Main Collapsible Property Cards Stack -->
        <main class="properties-stack">
          <div 
            v-for="(property, pIdx) in filteredProperties" 
            :key="property.id" 
            class="property-group-card"
          >
            <!-- Property Group Card Header -->
            <div class="property-header">
              
              
              <div class="property-info" >
                <div @click="property.isExpanded = !property.isExpanded">
                  <h2 class="property-name">{{ property.title }}</h2>
                  <p class="property-address">{{ property.address }}</p>
                </div>
                
                
                <!-- Metrics Status Counter Indicators -->
                <div class="metrics-row">
                  <span class="metric eligible">
                    <span class="dot green"></span>
                    {{ getEligibleCount(property) }} Eligible
                  </span>
                  <span v-if="getNotEligibleCount(property) > 0" class="metric not-eligible">
                    <span class="dot red"></span>
                    {{ getNotEligibleCount(property) }} Not-Eligible
                  </span>
                </div>

                <!-- <div class="checklist-card">
                  <div class="badge-icon-wrapper" :class="property.evidence_of_ownership_verified == 'YES'">
                   
                    <svg v-if="property.evidence_of_ownership_verified === 'YES'" viewBox="0 0 24 24" class="status-svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    
                   
                    <svg v-else viewBox="0 0 24 24" class="status-svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                  </div>

                  <div class="card-body-text">
                    <h2 class="item-title">Profile Verification</h2>
                    
                  </div>
                </div> -->
                <div class="checklist-card">
                  <div class="badge-icon-wrapper" :class="`status-${property.kyc_verified}`">
                    <!-- Completed Status Check SVG Icon -->
                    <svg v-if="property.kyc_verified === 'YES'" viewBox="0 0 24 24" class="status-svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    
                    <!-- Warning/Pending Action Attention SVG Icon -->
                    <svg v-else viewBox="0 0 24 24" class="status-svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                  </div>

                  <div class="card-body-text">
                    <h2 class="item-title">profile Verification</h2>
                    <!-- <p class="item-desc">{{ property.description }}</p> -->
                  </div>
                </div>
                <div class="checklist-card">
                  <div class="badge-icon-wrapper" :class="`status-${property.evidence_of_ownership_verified}`">
                    <!-- Completed Status Check SVG Icon -->
                    <svg v-if="property.evidence_of_ownership_verified === 'YES'" viewBox="0 0 24 24" class="status-svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    
                    <!-- Warning/Pending Action Attention SVG Icon -->
                    <svg v-else viewBox="0 0 24 24" class="status-svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                  </div>

                  <div class="card-body-text">
                    <h2 class="item-title">Ownership Verification</h2>
                    <!-- <p class="item-desc">{{ property.description }}</p> -->
                  </div>
                </div>
                <div class="checklist-card">
                  <div class="badge-icon-wrapper" :class="`status-${property.maintenance_issue ? unit.maintenance_issue : null}`">
                    <!-- Completed Status Check SVG Icon -->
                    <svg v-if="property.maintenance_issue === 'YES'" viewBox="0 0 24 24" class="status-svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    
                    <!-- Warning/Pending Action Attention SVG Icon -->
                    <svg v-else viewBox="0 0 24 24" class="status-svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                  </div>

                  <div class="card-body-text">
                    <h2 class="item-title">No Pending Property Issue</h2>
                    <!-- <p class="item-desc">{{ property.description }}</p> -->
                  </div>
                </div>
                <div class="checklist-card">
                  <div class="badge-icon-wrapper" :class="`status-${property.legal_issue ? unit.legal_issue : null}`">
                    <!-- Completed Status Check SVG Icon -->
                    <svg v-if="property.legal_issue === 'YES'" viewBox="0 0 24 24" class="status-svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    
                    <!-- Warning/Pending Action Attention SVG Icon -->
                    <svg v-else viewBox="0 0 24 24" class="status-svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                  </div>

                  <div class="card-body-text">
                    <h2 class="item-title">No Legal issue</h2>
                    <!-- <p class="item-desc">{{ property.description }}</p> -->
                  </div>
                </div>

                <label class="checkbox-container" style="margin-top: 18px" v-if="property.isExpanded == true">
                  <input
                    type="checkbox" 
                    :checked="isPropertyCardFullySelected(property)" 
                    @change="togglePropertyCardSelectAll(property)"
                  />
                  <span class="custom-checkbox" style="margin-right: 10px;"></span>
                  Select all Units
                </label>
              </div>
  
              <!-- Collapse Arrow Trigger Element -->
              <button 
                class="arrow-btn" 
                :class="{ 'rotate-arrow': !property.isExpanded }"
                @click="property.isExpanded = !property.isExpanded"
              >
                <svg viewBox="0 0 24 24">
                  <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
                </svg>
              </button>
            </div>
  
            <!-- Nested Child Units List Grid -->
            <div v-show="property.isExpanded" class="units-list-container">
              <div 
                v-for="(unit, uIdx) in property.properties" 
                :key="unit.id" 
                class="unit-row-item"
                :class="{ 'unit-disabled': unit.eligible == 'NO' }"
              >
                <!-- Left Section: Interactive State Nodes -->
                <div class="unit-left-block">
                  <!-- v-if="unit.eligible == 'YES'"  use checking only when eligibility is needed -->
                  <label class="checkbox-container">
                    <input 
                      type="checkbox" 
                      v-model="unit.isSelected" 
                    />
                    <span class="custom-checkbox"></span>
                  </label>
                  
                  <!-- <div v-else class="lock-icon-wrapper">
                    <svg viewBox="0 0 24 24" class="lock-svg">
                      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
                    </svg>
                  </div> -->
  
                  <div class="unit-meta-details">
                    <h3 class="unit-title">{{ unit.nomenclature_serial || 'No title'}} </h3>
                    <p :class="['unit-status-msg', unit.eligible == 'YES' ? 'status-ok' : 'status-err']">
                      {{ unit.eligible == 'YES' ? 'Eligible' : `${unit.tenancyagreement_provided + '  agreement'}` }}
                    </p>
                  </div>
                </div>
  
                <!-- Right Section: Price Metrics Display / Notice Flags -->
                <div class="unit-right-block">
                  <span class="unit-price-label">
                    &#8358;{{ formatPrice(unit.price) }}/yr
                  </span>
                  <!-- <div  class="alert-icon-wrapper">
                    <svg viewBox="0 0 24 24" class="alert-svg">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="12" y1="8" x2="12" y2="12"/>
                      <line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                  </div> -->
                </div>
              </div>
            </div>
  
          </div>
        </main>
        <div class="button-holder" v-if="!loading">
          <button class="btn main" @click="routeTo()" :disabled="selectedUnitsList.length == 0">Continue</button>
          <button class="btn cancel" @click="goBack()">Cancel</button>
        </div>
      </div>
    </div>
  </template>
  
<script>
  import { EventBus } from '@/event-bus.js';
  import { Service } from "../../store/service";
  const Api = new Service();
  import PageLoader from "../../components/PageLoader.vue";
  import EmptyState from "../../components/EmptyState.vue"; 
  export default {
    name: 'SelectProperty',
    components: {
        PageLoader,
        EmptyState
    },
    data() {
      return { 
        loading: false,
        searchQuery: '',
        properties: [],
        emptyDataObject: {
          header: "No Data yet",
          option: "You dont have any property uploaded yet"
        },
        properties2: [
          {
            id: 1,
            name: 'Harbor View Apartments',
            address: '122 Victoria Embankment, London',
            isExpanded: false,
            units: [
              { id: '1-1', name: 'Unit 1A', type: '2Bed', price: 3500000, isEligible: true, isSelected: false },
              { id: '1-2', name: 'Unit 1A', type: '2Bed', price: 3500000, isEligible: true, isSelected: false },
              { id: '1-3', name: 'Unit 1A', type: '2Bed', price: 3500000, isEligible: false, isSelected: false, reason: 'Missing Agreement' }
            ]
          },
          {
            id: 2,
            name: 'Blue City Estate',
            address: 'Centenary city gate, Lugbe Abuja',
            isExpanded: false,
            units: [
              { id: '2-1', name: 'Unit A', type: '2Bed', price: 3500000, isEligible: true, isSelected: false },
              { id: '2-2', name: 'Unit B', type: '2Bed', price: 3500000, isEligible: true, isSelected: false },
              { id: '2-3', name: 'Unit 1A', type: '2Bed', price: 3500000, isEligible: false, isSelected: false, reason: 'Missing Agreement' }
            ]
          }
        ]
      };
    },
    computed: {
      filteredProperties() {
        if (!this.searchQuery.trim()) return this.properties;
        const query = this.searchQuery.toLowerCase();
        return this.properties.filter(p => 
          p.title.toLowerCase().includes(query) || p.address.toLowerCase().includes(query)
        );
      },
      allEligibleUnits() {
        return this.properties.flatMap(p => p.properties).filter(u => u);
        // return this.properties.flatMap(p => p?.properties || [])
        // .filter(unit => unit.eligible === 'YES' && unit.isSelected).length;
      },
      // allEligibleUnits() {
      //   return this.properties.flatMap(p => p.properties).filter(u => u);
      // },
      totalEligibleUnitsCount() {
        return this.properties.flatMap(p => p?.properties || [])
      .filter(unit => unit.eligible === 'YES').length;
        // return this.allEligibleUnits.length;
 
      },
      isAllEligibleSelected() {
        const eligible = this.allEligibleUnits;
        return eligible.length > 0 && eligible.every(u => u.isSelected);
      },
      selectedUnitsList() {
        // console.log("bording check", this.properties)
        return this.properties.flatMap(property => 
        // property.properties.filter(unit => unit.eligible == 'YES' && unit.isSelected)
          (property?.properties || []).filter(unit => unit.on_guaranteed_rent == 'NO' && unit.isSelected).map(unit => ({
                  property_id: unit.id,
                  unitName: unit.nomenclature_serial || 'No title',
                  kyc_verified: unit.kyc_verified || 'NO',
                  // unitType: unit.type,
                  unitPrice: unit.price || 0,
                  propertyName: property.title,
                  rentDueDate: property.rent_due_date || 'No Date',
                  propertyAddress: property.address,
                  tenancyagreement_provided: property.tenancyagreement_provided || 'missing',
                  evidence_of_ownership_verified: property.evidence_of_ownership_verified || 'NO',
                  legal_issue: property.legal_issue || 'NO',
              }))
              
          );
        },
        onboardingSummaryPayload() {
            // 1. Get the list of unique selected property IDs
            // console.log("Prop cehck", this.properties);
            // const uniquePropertyIds = [
            //     ...new Set(
            //         this.properties
            //         .filter(p => p.properties?.some(u => u.isSelected))
            //         .map(p => p.id)
            //     )
               
            // ];
            const uniqueProperties = new Set();

            this.properties.forEach(p => {
              if (p.properties?.some(u => u.isSelected)) {
                uniqueProperties.add(p.address);
              }
            });

            return {
              selectedUnits: this.selectedUnitsList,
              totalPropertiesSelected: uniqueProperties.size, // Exact count of unique parents
              totalUnitsSelected: this.selectedUnitsList.length
            };
        }
    },
    watch: {
        /**
         * UPDATED WATCHER
         * Watches the new summary payload and emits it upstream
         */
        onboardingSummaryPayload: {
            deep: true,
            immediate: true,
            handler(newPayload) {
                // this.$emit('update-selection-summary', newPayload);
                // this.broadcastData(newPayload);
                sessionStorage.setItem('unitSelections', JSON.stringify(newPayload));
                // console.log("Total Selected Properties:", newVal.totalPropertiesSelected);
                // console.log("selected prop", newPayload);
                // console.log("check", this.selectedUnitsList)
            }
        }
    },
    mounted() {
      this.fetchLandlordProperties()
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      routeTo() {
        this.$router.push("activate-guarentee-rent");
      },
      // togglePropertyCardSelectAll(property) {
      //   const eligibleInCard = property?.properties?.filter(u => u.eligible == 'YES');
      //   const allCurrentlyChecked = eligibleInCard.every(u => u.isSelected);
      //   console.log("all current", allCurrentlyChecked)
        
      //   eligibleInCard.forEach(unit => {
      //     unit.isSelected = !allCurrentlyChecked;
      //   });
      // },
      // isPropertyCardFullySelected(property) {
      //   const eligibleInCard = property.properties.filter(u => u.eligible == 'YES');
      //   return eligibleInCard.length > 0 && eligibleInCard.every(u => u.isSelected);
      // },
      toggleGlobalSelectAll(event) {
        const checked = event.target.checked;
        this.properties.forEach(property => {
          // Loop through absolutely every unit regardless of eligibility
          property?.properties?.forEach(unit => {
            unit.isSelected = checked;
          });
        });
      },

      togglePropertyCardSelectAll(property) {
        const allUnits = property?.properties || [];
        if (allUnits.length === 0) return;

        // Evaluates true ONLY if every single item in this card is checked
        const allCurrentlyChecked = allUnits.every(u => u.isSelected);
        
        allUnits.forEach(unit => {
          unit.isSelected = !allCurrentlyChecked;
        });
      },

      isPropertyCardFullySelected(property) {
        const allUnits = property?.properties || [];
        // Returns true only if the array has items and every single one is selected
        return allUnits.length > 0 && allUnits.every(u => u.isSelected);
      },
      getEligibleCount(property) {
        return property.properties.filter(u => u.eligible == 'YES').length;
      },
      getNotEligibleCount(property) {
        return property.properties.filter(u => u.eligible == 'NO').length;
      },
      formatPrice(val) {
        return Number(val).toLocaleString();
      },
      async fetchLandlordProperties() {
        this.loading = true;
        try {
          Api.getRequest(`fetch-properties-for-guaranteed-rent-request`).then(res => {
            // console.log("Property list", res);
            this.loading = false;
            if (res.data.success) {
              // this.properties = res.data.data;

              const rawResponse = res.data.data; // This is the Array(1) containing the objects

              this.properties = rawResponse.map(batchItem => {
                return {
                  ...batchItem,
                  isExpanded: false, // 1. Added at the same level as 'address'
                  
                  // 2. Map through the nested properties array to inject 'isSelected'
                  properties: batchItem.properties ? batchItem.properties.map(property => ({
                    ...property,
                    isSelected: false // Added inside each property object
                  })) : [] // Fallback to empty array if properties is missing
                };
              });
              // console.log("Property destructure", this.properties);
            }
          }).catch(err => {
            console.log("error", err)
            this.loading = false;
          })
        } finally {
          // console.log("closed");
        }
      }
    }
  };
  </script>


<style lang="scss" scoped>
// Design System Tokens Map
$color-bg-page: #f8faff;
$color-white: #ffffff;
$color-text-main: #0c1424;
$color-text-secondary: #5f6a80;
$color-brand-blue: #0042eb;
$color-brand-dark-blue: #0033EA;
$color-border: #e2e9f3;
$color-disabled-gray: #e6ecf4;
$color-status-green: #10b981;
$color-status-orange: #f97316;
$color-text-title: #101623;
$color-text-subtitle: #596173;

.page-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  background-color: $color-bg-page;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  padding: 32px 16px;
  box-sizing: border-box;

  .card-wrapper {
    width: 100%;
    max-width: 480px;
    display: flex;
    flex-direction: column;
    background: #f8faff;
    box-shadow: 
      0 0 0 1px rgba(0, 0, 0, 0.05), 
      0 4px 12px rgba(0, 0, 0, 0.05), 
      0 12px 24px rgba(0, 0, 0, 0.05);
      padding: 15px;
      border-radius: 6px;
  }

  // Header Title Component
  .page-header {
    margin-bottom: 24px;

    .main-title {
      font-size: 22px;
      font-weight: 700;
      color: $color-text-main;
      margin: 0 0 8px 0;
      letter-spacing: -0.3px;
    }

    .subtitle {
      font-size: 14px;
      line-height: 1.45;
      color: $color-text-secondary;
      margin: 0;
    }
  }

  // Search input context box styling
  .search-container {
    margin-bottom: 24px;

    .search-input-wrapper {
      position: relative;
      display: flex;
      align-items: center;

      .search-icon {
        position: absolute;
        left: 16px;
        width: 20px;
        height: 20px;
        fill: #919db2;
      }

      .search-input {
        width: 100%;
        background-color: $color-white;
        border: 1.5px solid $color-border;
        border-radius: 14px;
        padding: 14px 16px 14px 48px;
        font-size: 15px;
        color: $color-text-main;
        box-sizing: border-box;
        outline: none;
        transition: border-color 0.2s ease;

        &:focus {
          border-color: $color-brand-blue;
        }

        &::placeholder {
          color: #919db2;
        }
      }
    }
  }

  // Global Checkbox Bar Styling
  .global-select-bar {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 24px;
    padding-left: 4px;

    .select-text-content {
      display: flex;
      flex-direction: column;
      gap: 2px;

      .select-all-label {
        font-size: 16px;
        font-weight: 600;
        color: $color-text-main;
        font-family: Lato;
      }

      .eligible-count {
        font-size: 13.5px;
        color: $color-text-secondary;
        font-weight: 500;
        font-family: Lato;
      }
    }
  }

  // Reusable Native Checkbox Component Skinning Matrix
  .checkbox-container {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    font-family: Lato;

    input {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;

      &:checked + .custom-checkbox {
        background-color: $color-brand-blue;
        border-color: $color-brand-blue;

        &::after {
          content: '';
          position: absolute;
          left: 6px;
          top: 2px;
          width: 5px;
          height: 10px;
          border: solid $color-white;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }
      }
    }

    .custom-checkbox {
      position: relative;
      width: 22px;
      height: 22px;
      background-color: $color-white;
      border: 1.5px solid #b0bac9;
      border-radius: 7px;
      box-sizing: border-box;
      transition: all 0.15s ease;
      font-family: Lato;
    }
  }


  .checklist-card {
    // background-color: $color-white;
    // border-radius: 18px;
    padding: 2px 0;
    display: flex;
    align-items: center;
    gap: 2px;
    // box-shadow: 0 2px 10px rgba(0, 50, 120, 0.015), 0 10px 24px rgba(0, 50, 120, 0.025);
    // border: 2px solid transparent;
    // transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-sizing: border-box;

    // Special active focused state box modifier styling
    &.card-active-focus {
      border-color: $color-brand-blue;
      box-shadow: 0 4px 14px rgba($color-brand-blue, 0.04), 0 14px 32px rgba($color-brand-blue, 0.06);
    }
    .badge-icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      min-width: 24px;
      border-radius: 50%;

      &.completed {
        background-color: rgba($color-status-green, 0.1);
        .status-svg { fill: $color-status-green; }
      }
      &.status-YES {
        background-color: rgba($color-status-green, 0.1);
        .status-svg { fill: $color-status-green; }
      }
      &.provided {
        background-color: rgba($color-status-green, 0.1);
        .status-svg { fill: $color-status-green; }
      }

      &.missing {
        background-color: rgba($color-status-orange, 0.15);
        .status-svg { fill: $color-status-orange; }
      }
      &.status-NO {
        background-color: rgba($color-status-orange, 0.15);
        .status-svg { fill: $color-status-orange; }
      }
      &.status-null {
        background-color: rgba($color-status-orange, 0.15);
        .status-svg { fill: $color-status-orange; }
      }

      .status-svg {
        width: 20px;
        height: 20px;
      }
    }
    .card-body-text {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .item-title {
        font-size: 13.5px;
        font-weight: 700;
        color: $color-text-title;
        margin: 0;
        letter-spacing: -0.2px;
        text-align: left;
        font-family: Lato;
      }

      .item-desc {
        font-size: 13.5px;
        color: $color-text-subtitle;
        margin: 0;
        font-weight: 400;
        font-family: Lato;
      }
    }
  }

  // Properties list structural layers
  .properties-stack {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .property-group-card {
      background-color: $color-white;
      border-radius: 18px;
      border: 1.5px solid $color-border;
      padding: 20px;
      box-shadow: 0 4px 12px rgba(0, 40, 100, 0.015);
      box-sizing: border-box;

      .property-header {
        display: flex;
        align-items: flex-start;
        gap: 16px;

        .property-info {
          flex: 1;
          cursor: pointer;
          text-align: left; // new addition;
          .property-name {
            font-size: 17px;
            font-weight: 700;
            color: $color-text-main;
            margin: 0 0 4px 0;
            line-height: 1.25;
          }

          .property-address {
            font-size: 13.5px;
            color: $color-text-secondary;
            margin: 0 0 10px 0;
            font-weight: 500;
          }

          .metrics-row {
            display: flex;
            align-items: center;
            gap: 14px;
            margin-bottom: 15px;

            .metric {
              display: inline-flex;
              align-items: center;
              gap: 6px;
              font-size: 13.5px;
              font-weight: 600;

              &.eligible { color: #10b981; }
              &.not-eligible { color: #ef4444; }

              .dot {
                width: 7px;
                height: 7px;
                border-radius: 50%;
                &.green { background-color: #10b981; }
                &.red { background-color: #ef4444; }
              }
            }
          }
        }

        .arrow-btn {
          background: none;
          border: none;
          cursor: pointer;
          padding: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.2s ease;

          svg {
            width: 22px;
            height: 22px;
            fill: #738096;
          }

          &.rotate-arrow {
            transform: rotate(180deg);
          }
        }
      }

      // Units container matrix row elements
      .units-list-container {
        margin-top: 18px;
        border: 1.5px solid $color-border;
        border-radius: 14px;
        overflow: hidden;

        .unit-row-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px;
          background-color: $color-white;
          border-bottom: 1.5px solid $color-border;
          box-sizing: border-box;

          &:last-child {
            border-bottom: none;
          }

          &.unit-disabled {
            background-color: #f1f4f9;

            .unit-left-block .unit-meta-details {
              .unit-title { color: #8e99a8; text-align: left; }
            }
          }

          .unit-left-block {
            display: flex;
            align-items: center;
            gap: 14px;

            .lock-icon-wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 22px;
              height: 22px;

              .lock-svg {
                width: 18px;
                height: 18px;
                fill: #bdc5d1;
              }
            }

            .unit-meta-details {
              display: flex;
              flex-direction: column;
              gap: 2px;

              .unit-title {
                font-size: 16px;
                font-weight: 600;
                color: $color-text-main;
                margin: 0;
                font-family: Lato;
              }

              .unit-status-msg {
                font-size: 13px;
                font-weight: 600;
                margin: 0;
                font-family: Lato;
                text-align: left;
                text-transform: capitalize;
                &.status-ok { color: #10b981; font-family: Lato; text-align: left; }
                &.status-err { color: #ef4444; font-family: Lato; text-align: left;}
              }
            }
          }

          .unit-right-block {
            .unit-price-label {
              font-size: 14.5px;
              font-weight: 700;
              color: #003EC7;
              font-family: Lato;
            }

            .alert-icon-wrapper {
              display: flex;
              align-items: center;
              justify-content: center;

              .alert-svg {
                width: 20px;
                height: 20px;
                fill: none;
                stroke: #bdc5d1;
                stroke-width: 2;
                stroke-linecap: round;
                stroke-linejoin: round;
              }
            }
          }
        }
      }
    }
  }
}

// Mobile Breakpoints Responsive Optimization
@media (max-width: 400px) {
  .page-container {
    padding: 20px 12px;

    .page-header {
      .main-title { font-size: 19px; }
      .subtitle { font-size: 13px; }
    }

    .search-container .search-input-wrapper .search-input {
      padding: 12px 14px 12px 42px;
      font-size: 14px;
    }

    .properties-stack .property-group-card {
      padding: 14px;

      .property-header {
        gap: 12px;
        .property-info {
          .property-name { font-size: 15.5px; }
          .property-address { font-size: 12.5px; }
          .metrics-row .metric { font-size: 12px; }
        }
      }

      .units-list-container .unit-row-item {
        padding: 12px;
        gap: 8px;

        .unit-left-block {
          gap: 10px;
          .unit-meta-details {
            .unit-title { font-size: 14px; text-align: left; font-family: Lato;}
            .unit-status-msg { font-size: 12px; text-align: left; font-family: Lato;}
          }
        }
        .unit-right-block .unit-price-label { font-size: 13px; }
      }
    }
  }
}

.button-holder {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    button {
      width: 100%;
      height: 50px;
      font-family: Lato;
      box-shadow: none;
      outline: 0;
    }
    .main {
      background-color: $color-brand-dark-blue;
      color: $color-white;
      margin-bottom: 15px;
    }
    .cancel {
      background-color: #E6F0FA;
      color: #0033EA;
    }
}
</style>

  